import { IAddProcessTemplate } from '../../models/forms/IAddUpdateProcessTemplate';
const initialState: IAddProcessTemplate = {
  TenantId: 0,
  TemplateName: '',
  Remarks: '',
  ProcesTemplates: [],
  Type: -1,
};

export default initialState;
